import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
} from "reactstrap"

import { Link, useLocation, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// import images
import profile from "assets/images/zithas-logo.png"
import ConfigUrl, { axiosbaseurl } from "../../config"
import Loader from "components/Common/Loader"
import Swal from "sweetalert2"
import axios from "axios"
import { SiTicktick } from "react-icons/si"
import secureLocalStorage from "react-secure-storage"
import { IoMdWarning } from "react-icons/io"
import { notification } from "antd"

const Login = props => {
  const Navigate = useNavigate()
  const location = useLocation()

  let p_id;
  const queryParams = new URLSearchParams(location.search)
  p_id = queryParams.get("p_id")

  if (!p_id) {
    p_id = secureLocalStorage.getItem("portfolioId")
  }

  async function getUserIP() {
    try {
      const response = await fetch("https://api.ipify.org?format=json")
      const data = await response.json()
      return data.ip
    } catch (error) {
      console.error("Failed to get IP address:", error)
      return null
    }
  }

  //meta title
  document.title = "Zithas Portfolio"

  const [name, setName] = useState("")
  const [email, setemail] = useState("")
  const [Loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({
    Name: "",
    email: "",
  })

  const handleLogin = async (e) => {
    e.preventDefault();
    if (email) {
      setLoading(true)
      try {
        const response = await axios.post(
          `${ConfigUrl.apiurl}/portfolio/client/login`,
          {
            portfolioId: p_id,
            name,
            email,
            ip: await getUserIP(),
          }
        )
        if (response?.data?.success) {
          setLoading(false)
          secureLocalStorage.setItem("isAuthenticated", true)
          secureLocalStorage.setItem("portfolioId", p_id)
          secureLocalStorage.setItem('')
          secureLocalStorage.setItem('loginId', response?.data?.data?.id)
          setTimeout(() => {
            Navigate(`${ConfigUrl.appurl}welcome${location?.search}`)
          }, 1000)
        } else {
          notification.error("Invalid link !")
        }
      } catch (e) {
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Oops! Something went wrong.</div>
            </div>
          ),
          description: e?.response?.data?.message,
        })
      } finally {
        setLoading(false)
      }
    } else {
      Swal.fire({
        title: "Login Failed",
        icon: "error",
      })
    }
  }

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <div className="account-pages">
        <Container>
          <Row className="justify-content-center row">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-darkblue bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4 mobile-login-p-2">
                        <h5 className="text-white">Start Your Experience</h5>
                        <p className="mb-0 text-white">Your Exclusive Access Awaits</p>
                      </div>
                    </Col>
                    <Col className="col-5 p-2 d-flex justify-content-end pe-3">
                      <div className="rofile-user-wid ">
                        <span className="avatar-title rounded-4 px-1">
                          <img src={profile} alt="" className="w-100" />
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-3 bg-light">
                  <div className="p-2">
                    <Form className="form-horizontal" onSubmit={handleLogin}>
                      <div className="mb-3">
                        <Label className="form-label">Provide Your Name</Label>
                        <input
                          name="Name"
                          className="form-control"
                          placeholder="Enter Your Name"
                          type="text"
                          onChange={e => setName(e.target.value)}
                          value={name}
                        />
                        {errors.Name && (
                          <span className="text-danger">{errors.Name}</span>
                        )}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Provide Your Email</Label>
                        <input
                          name="email"
                          value={email}
                          type="email"
                          placeholder="Enter Email Address"
                          className="form-control"
                          onChange={e => setemail(e.target.value)}
                        />
                        {errors.email && (
                          <span className="text-danger">{errors.email}</span>
                        )}
                      </div>

                      <div className="mt-4 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          style={{
                            backgroundColor: "#2D2966",
                            borderColor: "#2D2966",
                          }}
                        >
                          Explore Now <i className="fas fa-long-arrow-alt-right  fs-6"></i>
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
